export const transportDataGaza = {
  route: "Vaal → Gaza",

  pickupPoints: [
    "Malamulele",
    "Giyani",
    "Bungeni",
    "Phalaborwa",
    "Tzaneen",

  ],

  dropoffLocations: [
    "Vaal University of Technology Main Gate",
    "North-West University (Vanderbijlpark)",
    "Sedibeng College"
  ],

  pickupTransport: [
    "Venda → Vaal",
    "Gaza → Vaal",
    "Venda → JHB"
  ],

  travelDates: [
    "22 July Wednesday 10:00am",
    "26 July Saturday 10:00am",
    "29 July Tuesday 10:00am",
    "31 July Thursday 10:00am",
    "02 August Saturday 10:00am"
  ],

  fleet: [
    "15 Seater Taxi",
    "22 Seater Bus",
    "50 Seater Bus",
    "70 Seater Bus"
  ],

  pricing: {
    totalPrice: "480",
    deposit: "50"
  },

  contact: {
    whatsapp: "27766968457",
    displayWhatsapp: "+27 76 696 8457",
    email: "arenaho@gmail.com"
  },

  banking: {
    bank: "Capitec",
    accountNumber: "2436939590",
    accountOwner: "MR V MITHOBENI",
    reference: "Your Name + WhatsApp Number"
  },

  publicKey: "", // The secret key (sk) will be blocked by Yoco when called directly from a browser for security reasons.
};
